export default {
  slices: [
    {
      field: 'ad_categories',
      display: 'Ad Category',
      map: {
        all_retail: {
          display: 'All Retail',
          sortOrder: 1
        },
        big_box: {
          display: 'Big Box',
          sortOrder: 2
        },
        home_improvement: {
          display: 'Home Improvement',
          sortOrder: 3
        },
        ecommerce_focused: {
          display: 'Ecommerce Focused',
          sortOrder: 4
        },
        department_stores: {
          display: 'Department Stores',
          sortOrder: 5
        }
      }
    },
    {
      field: 'ad_type',
      display: 'Media Type',
      map: {
        video: {
          display: 'Video',
          mediaType: 'mp4',
          sortOrder: 1
        }
      }
    },
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetail/config/metadata.js